import React, { useState } from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import useTimeZoneSelectStyles from './styles'

const TimeZoneSelect = ({
  label,
  timeZones,
  selectedTimeZone,
  onTimeZoneChange,
}) => {
  const classes = useTimeZoneSelectStyles()

  const [searchTerm, setSearchTerm] = useState('')

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const filteredTimeZones = timeZones.filter((timeZone) =>
    timeZone.toLowerCase().includes(searchTerm.toLowerCase())
  )
  return (
    <div className={classes.root}>
      <FormControl sx={{ width: '100%' }}>
        <InputLabel id="demo-simple-select-filled-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-filled-label"
          id="demo-simple-select-filled"
          value={selectedTimeZone}
          onChange={onTimeZoneChange}
          sx={{
            borderRadius: '50px',
            backgroundColor: '#fff',
            boxShadow: '4px 4px 15px rgba(0, 0, 0, 0.05)',
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {filteredTimeZones &&
            filteredTimeZones.map((timeZone) => (
              <MenuItem key={timeZone} value={timeZone}>
                {' '}
                {timeZone}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  )
}

TimeZoneSelect.propTypes = {}

export default TimeZoneSelect
